<script lang="ts">
	import { onMount } from 'svelte';

	export let color = 'black';
	export let stripesCount = 10;
	export let stripWidth = 5;
	export let rotate = 20;
	export let icon = false;
	export let animate = false;
	export let spacing = 5;
	export let left = -200;
	export let top =0;
	export let backgroundColor = 'transparent';
	export let shadow =false;

	$: stripes = [];
	onMount(() => {
		for (let stripe = 0; stripe < stripesCount; stripe++) {
			stripes = [...stripes, stripe];
		}
	});
</script>

<div class="stripes {shadow  ? 'shadow':''}" style="background-color: {backgroundColor};">
	{#each stripes as stripe}
		<div
			class="stripe {animate ? 'animate' : ''} "
			style="background-color: {color}; 
            transform: rotateZ({rotate}deg);
            height: {stripWidth}px;
            margin-bottom: {spacing}px;
			left:{left}px;
			top:{top}px
            "
		/>
	{/each}
</div>
{#if icon}
	<div class="qmark">
		<div class="question-mark">?</div>
	</div>
{/if}

<style>
	.stripes,
	.qmark {
		
		position: relative;
		display: block;
		overflow: hidden;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.animate {
		animation-name: slide;
		animation-duration: 1s;
		animation-iteration-count: infinite;
		animation-fill-mode: both;
		animation-timing-function: linear;
	}

	@keyframes slide {
		from {
			left: 0px;
		}
		to {
			left: 50px;
		}
	}

	.stripe {
		position: relative;
		transform: rotateZ(20deg);
		width: 350px;
		margin-left: -20px;
		margin-bottom: 5px;
	}
	.question-mark {
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		color: seashell;
		background-color: transparent;
		z-index: 1;
	}
	.shadow{
		box-shadow: inset 4px 4px 15px 10px #000000;
	}
</style>
